export default __webpack_public_path__ + "app-inactive.bc7953c2dfebcabce2c43ca7dc778a89.png";